/**
 * Payroll → Reports.
 *
 * Spec: .claude/specs/reports-v2-shell-and-people-analytics.md (Package 1).
 *
 * Payroll cost moves here from the standalone /reports page, so it sits with
 * the module that owns the data. A tenant without the Payroll module never
 * reaches this route — the module guard handles that — but the endpoint still
 * degrades to an `unavailable_module` envelope rather than a 403, which
 * ReportShell renders as an explanation instead of an error (AC10).
 */
import React from "react";

import ReportShell from "../components/ReportShell";

export default function PayrollReportsPage() {
  return (
    <ReportShell
      report="payroll-cost"
      title="Payroll Cost"
      subtitle="What payroll cost over the period, by currency"
    />
  );
}
